import { render } from "./DropMenu.vue?vue&type=template&id=c066be00&scoped=true"
import script from "./DropMenu.vue?vue&type=script&lang=js"
export * from "./DropMenu.vue?vue&type=script&lang=js"

import "./DropMenu.vue?vue&type=style&index=0&id=c066be00&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c066be00"]])

export default __exports__